export enum PiggyInfoType {
    PIGGY = "PIGGY",
    TOKEN = "TOKEN",
    COUPON = "COUPON"
}